import React from 'react';
import makeCancelable from '../../api/cancelable';

export default class Cancellable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  request(apiPromise) {
    const { promise, cancel } = makeCancelable(apiPromise);
    this.requests.push(cancel);

    return promise;
  }
}



// WEBPACK FOOTER //
// ./app/components/Cancellable/Cancellable.jsx